import type { ShipType, ActionType } from '@fleetduel/shared'

// Grid assets
import tileWater from './grid/tile-water.svg'
import markerHit from './grid/marker-hit.svg'
import markerMiss from './grid/marker-miss.svg'
import markerSunk from './grid/marker-sunk.svg'
import reticle from './grid/reticle.svg'
import badgeSonar from './grid/badge-sonar.svg'

// Ship assets
import shipDestroyer from './ships/ship-destroyer.svg'
import shipPatrolBoat from './ships/ship-patrol-boat.svg'
import shipGhostSub from './ships/ship-ghost-sub.svg'

// UI assets
import iconStrike from './ui/icon-strike.svg'
import iconTorpedo from './ui/icon-torpedo.svg'
import iconSonar from './ui/icon-sonar.svg'
import logo from './ui/logo.svg'
import plateBanner from './ui/plate-banner.svg'
import emoteBubble from './ui/emote-bubble.svg'
import iconLock from './ui/icon-lock.svg'
import iconStats from './ui/icon-stats.svg'
import iconEmote from './ui/icon-emote.svg'

// FX assets
import fxHitFlash from './fx/fx-hit-flash.svg'
import fxSplash from './fx/fx-splash.svg'
import fxTorpedo from './fx/fx-torpedo.svg'
import fxSonarRing from './fx/fx-sonar-ring.svg'

// Splash theater reel posters (ART_GUIDE_v3 §11.7)
import reelPosterHormuz from './theaters/hormuz/reel-poster.svg'
import reelPosterGiuk from './theaters/giuk/reel-poster.svg'
import reelPosterScs from './theaters/scs/reel-poster.svg'
import reelPosterClassic from './theaters/classic/reel-poster.svg'

export { tileWater, markerHit, markerMiss, markerSunk, reticle, logo, badgeSonar }
export { plateBanner, emoteBubble, iconLock, iconStats, iconEmote }
export { fxHitFlash, fxSplash, fxTorpedo, fxSonarRing }

export const SHIP_ASSETS: Record<ShipType, string> = {
  destroyer: shipDestroyer,
  patrol_boat: shipPatrolBoat,
  ghost_sub: shipGhostSub,
}

export const ACTION_ICONS: Record<ActionType, string> = {
  strike: iconStrike,
  torpedo: iconTorpedo,
  sonar: iconSonar,
}

/**
 * Splash theater reel segments in ART_GUIDE_v3 §11.2 order.
 * `drift` names a keyframe in styles/animations.css; `accent` is the
 * caption underline color; captions are the uppercase theater names.
 */
export const REEL_SEGMENTS = [
  { id: 'hormuz', src: reelPosterHormuz, caption: 'STRAIT OF HORMUZ', accent: '#F4B942', drift: 'reel-dolly-lr' },
  { id: 'giuk', src: reelPosterGiuk, caption: 'GREENLAND', accent: '#8DA9C4', drift: 'reel-push' },
  { id: 'scs', src: reelPosterScs, caption: 'SOUTH CHINA SEA', accent: '#3DDC97', drift: 'reel-dolly-rl' },
  { id: 'classic', src: reelPosterClassic, caption: 'CLASSIC', accent: '#A6C6E1', drift: 'reel-push' },
] as const

export const FX_ASSETS = {
  hitFlash: fxHitFlash,
  splash: fxSplash,
  torpedo: fxTorpedo,
  sonarRing: fxSonarRing,
}

export const UI_ASSETS = {
  plateBanner,
  emoteBubble,
  iconLock,
  iconStats,
  iconEmote,
  badgeSonar,
}
